import { forwardRef } from 'react'
import Box, { type BoxProps } from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { useHasScrollbars } from 'lib/hooks/useHasScrollbars/useHasScrollbars'
import { mergeRefs } from 'lib/helpers/mergeRefs/mergeRefs'
import * as tkn from '../../Modal.tokens'

export interface IModalContentProps extends BoxProps {
  scroll?: boolean
  withDynamicDividers?: boolean
  withStaticDividers?: boolean
}

export const ModalContentPaddingX = { xs: 2, md: 3 } as const

export const ModalContent = forwardRef<HTMLDivElement, IModalContentProps>(
  ({ children, scroll = true, withDynamicDividers = scroll, withStaticDividers = false, ...props }, ref) => {
    const [modalContentRef, { vertical: isScrollable }] = useHasScrollbars<HTMLDivElement>({
      skip: !withDynamicDividers,
    })
    const withDividersOnScroll = scroll && withDynamicDividers && isScrollable

    return (
      <>
        {(withStaticDividers || withDividersOnScroll) && <Divider />}
        <Box
          {...props}
          ref={mergeRefs([modalContentRef, ref])}
          sx={{
            flexGrow: 1,
            paddingX: ModalContentPaddingX,
            paddingY: tkn.ModalSpacingContentVerticalDesktop,
            ...(scroll && { overflowY: 'auto' }),
            ...props.sx,
          }}
        >
          {children}
        </Box>
        {(withStaticDividers || withDividersOnScroll) && <Divider />}
      </>
    )
  },
)

ModalContent.displayName = 'ModalContent'
